/**
 * Styled Components - Created by miguelcanobbio on 06/07/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  .ant-btn-primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }

  .ant-btn:hover {
    color: #4a90e2;
    border-color: #4a90e2;
  }

  .ant-btn-primary:hover {
    color: #fff;
    background-color: #6ea6e7;
    border-color: #6ea6e7;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ModalFooter/styledComponents.tsx